export const ImageUrl = "https://calorie-finder.s3.eu-west-2.amazonaws.com/calorie"
export const API_BASE_URL = "https://stage-api.thecaloriefinder.com"
// export const API_BASE_URL = "http://localhost:3001"

export const BUCKET_URL = `https://calorie-finder.s3.eu-west-2.amazonaws.com/calorie`

